export const specialisationListConvertion = ({
  listOfSpecialisation,
  selectedIds = [],
  isEditActiveRole = false,
}) => {
  let listData =
    listOfSpecialisation?.length &&
    listOfSpecialisation?.map((item, index) => {
      return {
        title: `${item?.degree?.shortForm} - ${item?.stream?.name}`,
        value: item?.id,
        children: item?.stream?.specialisation?.map(data => {
          return {
            title: `${item?.degree?.shortForm} - ${data?.name}`,
            value: getSpecialisationKeyFormat({
              degreeStreamMapId: item?.id,
              specializationId: data?.id,
            }),
            specializationName: data?.name,
            specializationId: data?.id,
            degreeStreamMapId: item?.id,
            streamId: item?.stream?.id,
            disabled: isEditActiveRole
              ? selectedIds?.includes(
                  getSpecialisationKeyFormat({
                    degreeStreamMapId: item?.id,
                    specializationId: data?.id,
                  })
                )
              : false,
          }
        }),
      }
    })

  return listData?.length
    ? listData?.filter(stream => stream?.children?.length)
    : []
}

export const getSpecialisationKeyFormat = ({
  degreeStreamMapId = '',
  specializationId = '',
}) => {
  return degreeStreamMapId + '/' + specializationId
}

export const degreeIdFromString = keyValue => {
  return keyValue?.split('/')[0]
}
export const detectDateFormat = dateString => {
  const dateFormatRegex = [
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/,
    /\d{2}\/\d{2}\/\d{4}/,
    /\d{4}-\d{2}-\d{2}/,
  ]

  for (const regex of dateFormatRegex) {
    if (regex.test(dateString)) {
      return regex.toString().replace(/\//g, '').replace(/\\/g, '')
    }
  }

  return null
}

export const dateConversion = ({ date, convertTo }) => {
  const detectedFormat = detectDateFormat(date)
  if (convertTo === 'Date-Month-Year') {
    const getdate = new Date(date)
    const day = getdate.getUTCDate().toString().padStart(2, '0')
    const month = (getdate.getUTCMonth() + 1).toString().padStart(2, '0')
    const year = getdate.getUTCFullYear().toString()
    return `${day}-${month}-${year}`
  } else if (convertTo === 'Date/Month/Year') {
    const getdate = new Date(date)
    const day = getdate.getUTCDate().toString().padStart(2, '0')
    const month = (getdate.getUTCMonth() + 1).toString().padStart(2, '0')
    const year = getdate.getUTCFullYear().toString()
    return `${day}/${month}\/${year}`
  } else if (
    detectedFormat ===
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/
      .toString()
      .replace(/\//g, '')
      .replace(/\\/g, '')
  ) {
    if (convertTo === 'YYYY-MM-DD') {
      const formattedDate = new Date(date).toISOString().split('T')[0]
      return formattedDate
    }
  } else if (
    detectedFormat ===
    /\d{2}\/\d{2}\/\d{4}/.toString().replace(/\//g, '').replace(/\\/g, '')
  ) {
    if (convertTo == 'YYYY-MM-DD') {
      return date?.split('/')?.reverse()?.join('-')
    }
  } else if (
    detectedFormat ===
    /\d{4}-\d{2}-\d{2}/.toString().replace(/\//g, '').replace(/\\/g, '')
  ) {
    if (convertTo == 'DD/MM/YYYY') {
      return date?.split('-')?.reverse()?.join('/')
    }
  } else {
    let inputDate = new Date(date)

    let year = inputDate.getFullYear()
    let month = inputDate.getMonth() + 1
    let day = inputDate.getDate()

    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }

    let formattedDate = year + '-' + month + '-' + day

    return formattedDate
  }
}

export const timeString = time => {
  let inputDateString = time

  let inputDate = new Date(inputDateString)

  let hours = inputDate.getUTCHours()
  let minutes = inputDate.getUTCMinutes()

  let formattedTime = `${hours < 10 ? '0' + hours : hours}:${
    minutes < 10 ? '0' + minutes : minutes
  }`

  return formattedTime
}

export const timeCheck = timestamp => {
  if (!timestamp) {
    return null
  }

  if (/^\d{2}:\d{2}$/.test(timestamp)) {
    return timestamp
  }

  if (timestamp.toString().length > 12) {
    timestamp = Math.floor(timestamp / 1000)
  }

  let date = new Date(timestamp * 1000)

  let hours = date.getHours()
  let minutes = date.getMinutes()

  let formattedTime = `${hours < 10 ? '0' + hours : hours}:${
    minutes < 10 ? '0' + minutes : minutes
  }`

  return formattedTime
}

export const timeSplit = value => {
  const dateObject = new Date(value)

  const hours = dateObject.getUTCHours().toString().padStart(2, '0')
  const minutes = dateObject.getUTCMinutes().toString().padStart(2, '0')

  const time = `${hours}:${minutes}`
  return time
}

export const isReturnBoolean = (value, status, republishedDate, secondEdit = true) => {
  if (status == 0) {
    return true
  }
  if(republishedDate){
    const statuses = [
      'OPEN_FOR_APPLICATION',
      'ROLE_CLOSED',
      'APPLICATION_CLOSED',
      'EVALUATION_IN_PROGRESS',
      'COMPLETED',
    ]
    const filteredStatuses = statuses.filter(item => item !== status)
    return filteredStatuses.includes(value)
  }else if(!secondEdit && value != 'DRAFT' && value) {
    return true
  } else {
    return false
  }
}
